import wrapAsync from './wrapAsync';
import awaitify from './awaitify'

export default function (eachfn) {
    return function applyEach(fns, ...callArgs) {
        const go = awaitify(function (callback) {
            var that = this;
            return eachfn(fns, (fn, cb) => {
                wrapAsync(fn).apply(that, callArgs.concat(cb));
            }, callback);
        });
        return go;
    };
}



// WEBPACK FOOTER //
// ./~/async-es/internal/applyEach.js